<script>
export default {
  computed: {
    promotion() {
      return () => import(`@/components/Themes/${this.$cookies.get('theme') ?? 'default'}/Promotion`);
    }
  },
  methods: {},
};
</script>
<template>
  <component :is="promotion" v-if="promotion"></component>
</template>